/* Mirrors src/hooks/use-breakpoint.ts (Breakpoints.sm=640, lg=1024) and
   src/constants/theme.ts (Spacing, MaxContentWidth=1280).

   site-header.tsx picks the row padding, the desktop nav vs hamburger, and the
   sm-gated actions with a JS isSm/isLg check that only resolves after mount —
   on the web export the header renders in its mobile form first (shorter
   padding, hamburger) and grows ~8px taller when it swaps to desktop, pushing
   the whole page (hero included) down. These media queries resolve it at first
   paint instead. */

.row {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 8px 16px;
}

@media (min-width: 1024px) {
  .row {
    padding: 12px 24px;
  }
}

/* Inline nav: desktop only. */
.desktopNav {
  display: none;
}

/* Seven links: tighter just above the breakpoint, where the French labels
   would otherwise crowd the actions. */
@media (min-width: 1024px) {
  .desktopNav {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
  }
}

@media (min-width: 1280px) {
  .desktopNav {
    gap: 24px;
  }
}

.actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}

/* Favorites: hidden on the smallest screens. */
.smUp {
  display: none;
}

@media (min-width: 640px) {
  .smUp {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  }
}

/* Hamburger: everything below the desktop breakpoint. */
.hamburger {
  display: flex;
}

@media (min-width: 1024px) {
  .hamburger {
    display: none;
  }
}
